'use client'

import './skinResultsPanelSkeleton.css'
import HoverGradientButton from '@/components/buttons/HoverGradientButton/HoverGradientButton'

type Labels = { surveyCtaBanner: string; surveyCtaButton: string }

export function SkinResultsPanelSkeleton({ locale, labels }: { locale: string; labels: Labels }) {
  return (
    <div id="skin-results-panel-skeleton" className="skeleton-panel">
      {/* Left column skeleton */}
      <div className="skeleton-body">
        <div className="h-3 w-24 rounded bg-black/10 mb-2" />
        <div className="h-8 w-16 rounded bg-black/10 mb-2" />
        <div className="h-5 w-48 rounded bg-black/10 mb-4" />
        <div className="space-y-2">
          <div className="h-3 w-full rounded bg-black/10" />
          <div className="h-3 w-5/6 rounded bg-black/10" />
          <div className="h-3 w-4/6 rounded bg-black/10" />
        </div>
      </div>

      {/* Right column skeleton — radar chart placeholder */}
      <div className="skeleton-chart">
        <div className="h-3 w-40 rounded bg-black/10 mb-3" />
        <div className="rounded-full bg-black/10" style={{ width: 240, height: 320 }} />
      </div>

      {/* CTA overlay */}
      <div className="skeleton-overlay">
        <p className="text-black/70 text-sm text-center max-w-xs px-4">
          {labels.surveyCtaBanner}
        </p>
        <HoverGradientButton href={`/${locale}/survey`}>
          {labels.surveyCtaButton}
        </HoverGradientButton>
      </div>
    </div>
  )
}
